import PropTypes from 'prop-types';
import PayPrograms from '../constants/payPrograms';

const ProgramPropType = PropTypes.oneOf(Object.values(PayPrograms));

export default ProgramPropType;
